module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tpvok/tpvok.component.css
// module id = ./src/app/components/tpvok/tpvok.component.css
// module chunks = main